import NewPostComponent from './new-post.component';
import OrgNewPostComponent from './org-new-post.component';
import { useTheme } from '@mui/material/styles';
import { useLocation } from 'react-router-dom';
import { useMediaQuery } from '@mui/material';
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { StyledComponent } from 'src/components/styled-components/styledComponent';
import { CommonHelper } from 'src/utils/commonHelper';
import { DemoHelper } from 'src/utils/demoUtil/demoUtil';


const CommonNewPostComponent = () => {
  const { t: translate } = useTranslation();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [isOrgConnectedProfilesOpen, setOrgConnectedProfilesOpen] = useState(CommonHelper.GetIsOrgLevelEvent());
  const hasOrgAdminPermission = CommonHelper.CheckForPermissionAvailableForUser(CommonHelper.PermissionList.ORG_ADMIN);
  const isShowOfferBanner = CommonHelper.ShowOfferBanner();


  const handleOrgConnectedProfiles = (event) => {
    const checked = event.target.checked;
    setOrgConnectedProfilesOpen(checked);
    CommonHelper.SetIsOrgLevelEvent(checked);
  };

  useEffect(() => {
    if (location.state?.data?.is_org_level_post !== undefined) {
      setOrgConnectedProfilesOpen(location.state.data.is_org_level_post);
      CommonHelper.SetIsOrgLevelEvent(location.state.data.is_org_level_post);
    }
  }, [location.state]);

  return (
    <>
      <Helmet>
        <title>{translate('common.create_new_post', 'Create New Post')}</title>
      </Helmet>

      {hasOrgAdminPermission && !isMobile && !DemoHelper.IsDemoAccount() &&(
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            mb: 1,
          }}
        >
          <Typography
            variant="body1"
            sx={{
              fontWeight: 'bold',
              color: 'text.primary',
            }}
          >
            {translate('common.enable_org_level_posts', 'Enable Org Level Posts')}
          </Typography>
          <StyledComponent.SwitchIcon
            size="small"
            checked={isOrgConnectedProfilesOpen}
            onChange={handleOrgConnectedProfiles}
          />
        </Box>
      )}

      {isOrgConnectedProfilesOpen ? <OrgNewPostComponent isShowOfferBanner={isShowOfferBanner}/> : <NewPostComponent isShowOfferBanner={isShowOfferBanner}/>}
    </>
  );
};

export default CommonNewPostComponent;
